import * as React from "react";
const SvgFiRrCameraViewfinder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-camera-viewfinder_svg__a)">
      <path
        fill="#062147"
        d="M8 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5v-2a1 1 0 1 1 2 0v2c0 1.654 1.346 3 3 3h2a1 1 0 0 1 1 1m15-7a1 1 0 0 0-1 1v2c0 1.654-1.346 3-3 3h-2a1 1 0 1 0 0 2h2c2.757 0 5-2.243 5-5v-2a1 1 0 0 0-1-1M19 0h-2a1 1 0 1 0 0 2h2c1.654 0 3 1.346 3 3v2a1 1 0 1 0 2 0V5c0-2.757-2.243-5-5-5M1 8a1 1 0 0 0 1-1V5c0-1.654 1.346-3 3-3h2a1 1 0 1 0 0-2H5C2.243 0 0 2.243 0 5v2a1 1 0 0 0 1 1m11 2a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 10m3 7H9c-1.654 0-3-1.346-3-3v-4a3.003 3.003 0 0 1 2.953-2.999l.696-1.083A1.99 1.99 0 0 1 11.331 5h1.338c.685 0 1.313.344 1.683.919l.695 1.082A3 3 0 0 1 18 10v4c0 1.654-1.346 3-3 3m1-7a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-camera-viewfinder_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCameraViewfinder;
